<template>
  <v-container :fluid="true">
    <!--
  <div id="ckeditor" />
  FROM
  https://ckeditor.com/docs/ckeditor5/latest/installation/integrations/vuejs-v3.html#installing-plugins
-->
    <div
      class="editor-container editor-container_classic-editor"
      ref="editorContainerElement"
    >
      <div class="editor-container__editor">
        <div ref="editorElement" id="editor-container" :height="height">
          <!--
					<ckeditor v-if="isLayoutReady" v-model="config.initialData" :editor="editor" :config="config" />
					created using: https://ckeditor.com/ckeditor-5/builder/
				-->
          <ckeditor
            id="ckeditor"
            v-if="isLayoutReady"
            v-model="editorData"
            :editor="editor"
            :config="editorConfig"
            @ready="onEditorReady"
            @focus="onEditorFocus"
            @blur="onEditorBlur"
            @input="onEditorInput"
            @destroy="onEditorDestroy"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
// https://ckeditor.com/docs/ckeditor5/latest/api/module_editor-classic_classiceditor-ClassicEditor.html
import {
  ClassicEditor,
  AccessibilityHelp,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  BalloonToolbar,
  Base64UploadAdapter,
  BlockQuote,
  Bold,
  Clipboard,
  Code,
  CodeBlock,
  Essentials,
  FindAndReplace,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  HorizontalLine,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  SelectAll,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline,
  Undo
} from 'ckeditor5'

import { Ckeditor } from '@ckeditor/ckeditor5-vue'
import { WProofreader } from '@webspellchecker/wproofreader-ckeditor5'

import { toast } from 'vue3-toastify'

// import ClipboardPluginNoContent from './plugins/ClipboardPluginNoContent.js'

import NOtranslations from 'ckeditor5/translations/no.js'
import ENtranslations from 'ckeditor5/translations/en.js'

import 'ckeditor5/ckeditor5.css'

export default {
  name: 'RichEditor',
  components: {
    Ckeditor
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    },
    globalOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    insertText: {
      type: Object,
      required: false,
      default: () => ({})
    },
    initialText: {
      type: String,
      required: false,
      default: ''
    },
    editorType: {
      type: String,
      required: false,
      default: 'full'
    },
    peerreview: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      required: false,
      default: '--var(--editor-height)'
    },
    width: {
      type: String,
      required: false,
      default: '--var(--editor-width)'
    },
    contentLanguage: {
      type: String,
      required: false,
      default: 'en'
    },
    webform: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  setup() {
    /*
        console.log('SETUP 2')
        console.log(document.getElementById('#ckeditor'))
        console.log(document.getElementById('ckeditor'))

        ClassicEditor.create(document.querySelector('#ckeditor'))
            // ClassicEditor.create(document.getElementById('#ckeditor'))
            .then((ok) => {
                console.log('EDITOR INITIALIZED')
                console.log(ok)
            })
            .catch((error) => {
                console.error(error)
            })
             */
  },
  data() {
    return {
      isLayoutReady: false,
      options2: {},
      content2: '',
      editorData: this.initialText,
      editor: ClassicEditor,
      //editor: ClassicEditor,
      localEditor: null,
      editorConfig: {}
    }
  },
  watch: {
    // Watch content change
    content(newVal, oldVal) {
      console.log('====== CONTENT (%s) (%s)', newVal, this.disabled)
    },
    // Watch content change
    value(newVal, oldVal) {
      //    console.log('====== VALUE (%s)', newVal)
    },
    // Watch disabled change
    disabled(newVal, oldVal) {},
    insertText(newValue, oldValue) {
      console.log('InserText got updated')
      console.log(newValue)
      console.log(oldValue)
    },
    initialText(newVal, oldVal) {
      this.editorData = newVal
      // let initalDelta = new Delta().insert(newVal)
      // console.log('WATCH: initial text new (%s) old (%s)', newVal, oldVal)
    }
  },
  beforeCreate() {},
  beforeMount() {
    console.log('BEFORE CREATE (%J)', this.editorConfig)
    /*
        ClassicEditor.create(
            document.querySelector('#ckeditor'),
            this.editorConfig
        )
            .then((editor) => {
                console.log('Editor was initialized', editor)
                this.editor = editor
            })
            .catch((error) => {
                console.error('Editor initialization failed', error.toString())
                console.error(error)
            })
        */
  },
  mounted() {
    console.log(
      'MOUNTED (%s) (%s) (%s)',
      this.$i18n.locale,
      this.editorType,
      this.contentLanguage
    )
    // console.log(document.getElementById('#ckeditor'))
    // console.log(document.getElementById('ckeditor'))

    console.log(
      'MOUNTED: initial Text (%s) (%s)',
      this.editorType,
      this.initialText
    )
    // console.log("TOOLBAR OPTIONS (%j)", this.getToolbarOptions());
    console.log('---EDITOR---')
    console.log(this.editor)
    this.editorConfig = {
      /* https://ckeditor.com/docs/ckeditor5/latest/api/module_core_editor_editorconfig-EditorConfig.html */
      fontSize: {
        options: [
          { title: 'Small', model: '10px' },
          { title: 'Default', model: '16px' },
          { title: 'Big', model: '20px' }
        ]
      },
      toolbar: this.getToolbarOptions(),
      plugins: this.getPluginsOptions(),
      balloonToolbar: this.getBalloonToolbarOptions(),
      heading: this.getHeadingOptions(),
      image: this.getImageOptions(),
      link: this.getLinkOptions(),
      removePlugins: this.removePlugins(),
      language: {
        ui: this.getUILanguage(),
        content: this.getContentLanguage()
      },
      fontFamily: {
        supportAllValues: true
      },
      fontSize: {
        options: [10, 12, 14, 'default', 18, 20, 22],
        supportAllValues: true
      },
      wordCount: {
        onUpdate: (stats) => {
          // Prints the current content statistics.
          console.log(`Characters: ${stats.characters}\nWords: ${stats.words}`)
        }
      },
      placeHolder: this.initialText,
      initialData: this.initialText,
      menuBar: {
        isVisible: true
      },
      table: this.getTableOptions(),
      translations: this.getEditorLanguages()
    }
    this.isLayoutReady = true
    this.initialize()
    console.log('AFTER MOUNTED CREATE (%J)', this.editorConfig)
  },
  beforeUnmount() {
    console.log('Editor destroyed')
    this.options2 = {}
  },
  methods: {
    // Init CKEditor5 instance
    initialize() {
      console.log('INITIALIZE EDITOR GOT CALLED ')
      console.log(this.editorType)
      /*
            this.ckEditor.editing.view.document.on(
                'clipboardInput',
                (evt, data) => {
                    console.log('Clipboard input event')
                    console.log(evt)
                    console.log(data)
                }
            )
            */
      // this.$emit('ready')
    },
    getEditorLanguages() {
      console.log('GET EDITOR LANGUAGES (%s)', this.$i18n.locale)
      switch (this.$i18n.locale) {
        case 'en':
          return [ENtranslations]
        case 'nb':
          return [NOtranslations]
        default:
          return [ENtranslations]
      }
    },
    getLinkOptions() {
      if (this.editorType === 'simple') {
        return {}
      } else if (this.editorType == 'basic') {
        return {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        }
      } else {
        // full
        return {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        }
      } // else
    },
    removePlugins() {
      if (this.editorType === 'simple') {
        return []
      } else if (this.editorType == 'basic') {
        return []
      } else {
        return []
      }
    },
    getTableOptions() {
      if (this.editorType === 'simple') {
        return {}
      } else if (this.editorType == 'basic') {
        return {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties'
          ]
        }
      } else {
        // full
        return {
          contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells',
            'tableProperties',
            'tableCellProperties'
          ]
        }
      } // else
    },
    getListOptions() {
      if (this.editorType === 'simple') {
        return {}
      } else if (this.editorType == 'basic') {
        return {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        }
      } else {
        return {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        }
      } // else
    },
    getImageOptions() {
      if (this.editorType === 'simple') {
        return {}
      } else if (this.editorType == 'basic') {
        return {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ]
        }
      } else {
        // full
        return {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ]
        }
      } // else
    },
    getHeadingOptions() {
      if (this.editorType === 'simple') {
        return {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            }
          ]
        }
      } else if (this.editorType == 'basic') {
        return {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4'
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5'
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6'
            }
          ]
        }
      } else {
        // full
        return {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4'
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5'
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6'
            }
          ]
        }
      } // else
    },
    getBalloonToolbarOptions() {
      if (this.editorType === 'simple') {
        return ['bold', 'italic']
      } else if (this.editorType == 'basic') {
        return [
          'bold',
          'italic',
          '|',
          'link',
          'insertImage',
          '|',
          'bulletedList',
          'numberedList'
        ]
      } else {
        return [
          'bold',
          'italic',
          '|',
          'link',
          'insertImage',
          '|',
          'bulletedList',
          'numberedList'
        ]
      }
    },
    getPluginsOptions() {
      if (this.editorType === 'simple') {
        return [Heading, Bold, Essentials, Italic, Paragraph, List]
      } else if (this.editorType == 'basic') {
        return [
          Heading,
          Bold,
          Essentials,
          Italic,
          Paragraph,
          BlockQuote,
          List,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar
        ]
      } else {
        return [
          AccessibilityHelp,
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          BalloonToolbar,
          Base64UploadAdapter,
          BlockQuote,
          Bold,
          Code,
          CodeBlock,
          Essentials,
          FindAndReplace,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Heading,
          Highlight,
          HorizontalLine,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsert,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SelectAll,
          SpecialCharacters,
          SpecialCharactersArrows,
          SpecialCharactersCurrency,
          SpecialCharactersEssentials,
          SpecialCharactersLatin,
          SpecialCharactersMathematical,
          SpecialCharactersText,
          Strikethrough,
          Subscript,
          Superscript,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline,
          Undo
        ]
      } // else
    },
    getToolbarOptions() {
      if (this.editorType === 'simple') {
        return ['heading', 'bold', 'italic', 'numberedList', 'bulletedList']
      } else if (this.editorType == 'basic') {
        return [
          'heading',
          'bold',
          'italic',
          'numberedList',
          'bulletedList',
          '|',
          'insertTable',
          'blockQuote'
        ]
      } else {
        // full
        return {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'link',
            'insertImage',
            'insertTable',
            'highlight',
            'blockQuote',
            'codeBlock',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'indent',
            'outdent'
          ],
          shouldNotGroupWhenFull: false
        }
      } // else
    },
    getExtraOptions() {
      return {
        Plugins: [Image2],
        //toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote','|','insertImage','mediaEmbed'],
        extraPlugins: 'base64image',
        removeDialogTabs: 'image:advanced;link:advanced' //
      }
    },
    getUILanguage() {
      switch (this.$i18n.locale) {
        case 'en':
          return 'en'
        case 'nb':
          return 'nb'
        default:
          return 'nb'
      }
    },
    getContentLanguage() {
      return this.contentLanguage
    },
    onEditorReady(editor) {
      console.log('EDITOR GOT READY EVENT ! ')
      // this.localEditor = val
      // this.localEditor.plugins.get('Clipboard').isEnabled = false
      //      this.localEditor.plugins.get(Clipboard);
      if (this.editorType === 'simple' || this.editorType === 'basic') {
        editor.editing.view.document.on('clipboardInput', (evt, data) => {
          console.log('Clipboard input event')
          console.log(evt)
          console.log(data)
          const content =
            data.dataTransfer.getData('text/html') ||
            data.dataTransfer.getData('text/plain')
          console.log('Clipboard content:', content)
          evt.stop()
          data.content = editor.data.processor.toView('')
          toast.info(this.$t('toast.clipboarddisabled'), {
            timeout: 3000
          })
        })
      }
      if (this.editorType === 'simple') {
        editor.editing.view.change((writer) => {
          writer.setAttribute(
            'spellcheck',
            'false',
            editor.editing.view.document.getRoot()
          )
        })
      }

      this.$emit('ready', 'ready')
    },
    onEditorFocus() {
      console.log('EDITOR GOT FOCUS EVENT !')
      this.$emit('focus', 'focs')
    },
    onEditorBlur() {
      console.log('EDITOR GOT BLUR EVENT !')
      // this.$emit('blur', 'blur')
      this.$emit('blur', this.editorData)
    },
    onEditorInput() {
      console.log('EDITOR GOT INPUT EVENT ! (%s)', this.editorData)
      // this.$emit('input', 'input')
      this.$emit('input', this.editorData)
      this.$emit('change', this.editorData)
    },
    onEditorDestroy() {
      console.log('EDITOR GOT DESTROY EVENT !')
      this.editor = null
    }
  }
}
</script>

<style>
.ai4afl-editor {
  -webkit-user-select: text;
  user-select: text;
}

.ck-editor__editable[role='textbox'] {
  min-height: 100px; /* Optional: set minimum height for the editor */
  max-height: 67vh;
}

#editor-container {
  width: 95% !important;
  /*  width: 3500px !important; */
  max-width: 100% !important;
}
</style>
